"use client";

import {
  BadgeCheck,
  Banknote,
  Lock,
  PhoneCall,
  ShieldCheck,
  Sparkles,
  TrendingUp,
  Unlock,
  Users,
  Wrench,
} from "@/components/icons";

export const LOOM_EMBED_URL = "https://www.loom.com/embed/01e0cea6d35a4aee90cf50cb61f88496";

export const BENEFITS = [
  {
    icon: Banknote,
    highlight: "$200 – $1,600 / month",
    title: "Monthly passive income",
    description:
      "Earn between $200 and $1,600 USD every single month. No technical know-how is required and we provide any technical support you may need.",
  },
  {
    icon: ShieldCheck,
    highlight: "Zero cost to you",
    title: "All expenses covered",
    description:
      "All expenses related to hosting our equipment will be paid for by Proxidize. We're not asking for any money from you.",
  },
  {
    icon: Users,
    highlight: "$200 per referral",
    title: "Unlimited referral earnings",
    description:
      "Earn $200 for every successful referral. There's no limit on the number of referrals or how much you can earn.",
  },
] as const;

export const STEPS = [
  {
    icon: Wrench,
    title: "Kit Setup",
    description:
      "Proxidize will do all the heavy lifting for you. We'll send you a kit to host along with all the equipment you need to set it up.",
  },
  {
    icon: PhoneCall,
    title: "Schedule Call",
    description:
      "Once your kit has arrived, we'll walk you through the whole setup process, which only takes abutes.",
  },
  {
    icon: TrendingUp,
    title: "Profit",
    description:
      "Once the kit is up and running, you start earning between $200 and $1,600 every month!",
  },
] as const;

export const TESTIMONIALS = [
  {
    quote:
      "Hosting Proxidize hardware has been one of the easiest side hustles I've tried. I just plugged it in, followed the setup, and it started working automatically. Every month I receive payouts without lifting a finger. It's a simple way to earn passive income while helping grow the Proxidize network.",
    author: "Daniel",
    location: "New York, USA",
  },
  {
    quote:
      "I was skeptical at first, but hosting Proxidize hardware turned out to be a reliable source of income. I've been hosting for 6 months now, and the payments always arrive on time. It feels good knowing my unused internet and space are being put to work while I get paid.",
    author: "Jessica",
    location: "Austin, USA",
  },
  {
    quote:
      "What I love about Proxidize is not only the earning potential but also the support team. Whenever I had a question during setup, they responded quickly and guided me through. The hardware runs smoothly, and I barely notice it's there — except when I see my payout each month!",
    author: "Michael",
    location: "Chicago, USA",
  },
] as const;

export const ASSURANCES = [
  {
    icon: Unlock,
    title: "Easy to Join",
    description:
      "You don't have to be a Proxidize customer to host a kit and we aren't asking you to pay a penny. We'll pay for everything you need to host our kits.",
  },
  {
    icon: Sparkles,
    title: "Plug & Play",
    description:
      "To set the kit up you'll initially need between 15–45 minutes. You don't need any technical know-how — even your grandma can do it!",
  },
  {
    icon: Lock,
    title: "Privacy Commitment",
    description:
      "None of your data will be shared, including your IP address, which will be hidden behind our internal VPN network.",
  },
  {
    icon: BadgeCheck,
    title: "Legally Covered",
    description:
      "Proxidize bears all legal responsibility associated with ensuring the kit is used in compliance with all laws and regulations. We have it in our contract.",
  },
] as const;

// ─── Form select options ──────────────────────────────────────────────────────

export const ADDRESS_TYPES = [
  "Single-family home",
  "Apartment / condo",
  "Office",
  "Warehouse / commercial",
  "Other",
];

export const YES_NO_MAYBE = ["No", "Maybe", "Yes"];

export const TEST_ENVIRONMENTS = ["Indoors", "Outdoors"];

export const APPLYING_FOR = ["Myself", "Someone I know"];

export const REFER_OPTIONS = ["Yes, I'm interested", "Maybe later", "No, just applying for myself"];
